import { HoursClient } from './hours-client';
export default function HoursPage() { return <HoursClient />; }
